import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FragQueryService } from 'src/injectables/frag-query.service';
import { DialogService } from '../dialog.service';
import { Device } from '@models';
import { WebClient } from '@injectables';

@Component({
    selector: 'dialog-live-tag-default-configs',
    templateUrl: './dialog-live-tag-default-configs.component.html',
    styleUrls: ['./dialog-live-tag-default-configs.component.scss']
})
export class DialogLiveTagDefaultConfigsComponent implements OnInit {
    public defaultDensity: number | null = null;
    private device: Device;
    private readonly device$ = this.fragQuery.device$;
    public readonly quantityUnitSystem$ = this.fragQuery.QuantityUnitSystem$;

    constructor(
        private readonly webClient: WebClient,
        protected readonly dialog: DialogService,
        private readonly fragQuery: FragQueryService,
        private readonly host: MatDialogRef<boolean>,
    ) { }

    public ngOnInit(): void {
        this.device$.subscribe(device => {
            this.device = device;
            try {
                const defaultConfigs = JSON.parse(this.device.defaultConfigs ?? '{}');
                this.defaultDensity = defaultConfigs.truckMaterialDensity || null;
            } catch (error) {
                console.error('Failed to parse defaultConfig:', error);
                this.defaultDensity = null;
            }
        });
    }

    public cancel(): void {
        this.host.close(false);
    }

    public async save(): Promise<void> {
        try {
            const defaultConfigs = JSON.parse(this.device.defaultConfigs || '{}');
            defaultConfigs.truckMaterialDensity = this.defaultDensity;
            this.device.defaultConfigs = JSON.stringify(defaultConfigs);

            await this.dialog.await(this.webClient.model.device.save(this.device));
            this.host.close(true);
        } catch (error) {
            console.error('Error saving device:', error);
        }
    }
}
